import swal from 'sweetalert';
import template from './stavkaCjenika.html';
import ListController from '../common/list.controller.js';

class StavkaCjenikaController extends ListController {
    constructor(DS, AppConfiguration, $q, $uibModal, logger) {
        super();
        this.DS = DS;
        this.$q = $q;
        this.logger = logger;
        this.$uibModal = $uibModal;
        this.Model = DS.definitions['StavkaCjenika'] || false;
        this.view = AppConfiguration().getViewByEntityAndType('StavkaCjenika', 'ListView');

        this.icon = this.view.icon();
        this.pageTitle = this.view.getTitle({ naziv: this.cjenik.naziv });
        this.pageDesc = this.view.description();

        this.getState();
    }

    getState() {
        this.resolveReferences().then(() => {
            this.getItems();
        });
    }

    resolveReferences() {
        let models = [];
        let datastore = this.datastore();

        _.forOwn(this.view.getReferences(), (value, key) => {
            models.push(datastore.definitions[value.targetEntity().name()]);
        });

        return this.$q.all(models.map(m => m.findAll()));
    }

    getQueryset(params) {
        const cloneParams = { ...params };
        cloneParams.cjenik = this.cjenik.id;
        return this.Model.findAll(cloneParams, { bypassCache: true });
    }

    datastore() {
        return this.DS;
    }

    insert() {
        const model = {
            cjenik: this.cjenik.id
        };
        const entity = this.view.entity;
        const view = entity.creationView();
        const modal = this.$uibModal.open({
            component: 'modalForm',
            size: 'lg',
            resolve: {
                item: function() {
                    return model;
                },
                view: function() {
                    return view;
                }
            }
        });

        modal.result.then(model => {
            this.Model.create(model)
                .then(() => {
                    this.Model.ejectAll();
                    this.getState();
                })
                .catch(error => {
                    this.logger.error('Oupss...', error.data);
                });
        });
    }

    edit(item) {
        const model = item;
        const entity = this.view.entity;
        const view = entity.creationView();
        const modal = this.$uibModal.open({
            component: 'modalForm',
            size: 'lg',
            resolve: {
                item: function() {
                    return model;
                },
                view: function() {
                    return view;
                }
            }
        });

        modal.result.then(model => {
            this.Model.update(model.id, model)
                .then(() => this.getState())
                .catch(error => {
                    this.logger.error('Oupss...', error.data);
                });
        });
    }

    delete(item) {
        const previousWindowKeyDown = window.onkeydown;
        swal(
            {
                title: 'Brisanje retka stavke cjenika ',
                text: `Za potvrdu brisanja upišite 'da'`,
                type: 'input',
                showCancelButton: true,
                closeOnConfirm: false
            },
            inputValue => {
                window.onkeydown = previousWindowKeyDown;
                if (inputValue === false) return false;
                if (inputValue === 'da') {
                    this.Model.destroy(item.id).then(
                        data => {
                            this.getState();
                            swal('Redak obrisan', '', 'success');
                        },
                        error => {
                            swal('Greška', `Došlo je do greške prilikom brisanja`, 'error');
                        }
                    );
                    return true;
                }
                swal.showInputError('Nedozvoljena vrijednost');
                return false;
            }
        );
    }
}

StavkaCjenikaController.$inject = ['DS', 'AppConfiguration', '$q', '$uibModal', 'logger'];

const StavkaCjenikaComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: StavkaCjenikaController,
    controllerAs: 'vm',
    bindings: {
        cjenik: '<'
    }
};

export { StavkaCjenikaComponent };



// WEBPACK FOOTER //
// ./app/components/cjenik/stavkaCjenika.component.js